export default __webpack_public_path__ + "static/char-s-38-zh-Hans-1e70ee3c920d6c22b9f7aa1aa507630b.png";